/* Print Phuket: justified body text (pp-justify.css) with sensible exceptions.
   Keeps centred / right-aligned text as designed, and leaves narrow blocks (< 300px) and card captions inside links left-aligned, because justify leaves ugly word gaps there. */
(function(){
  var SEL='.main-content :is(p,li,dd,blockquote)';
  var MIN=300;
  function sheet(){return document.querySelector('link[href*="pp-justify"]');}
  function run(){
    var l=sheet();if(!l)return;
    var els=document.querySelectorAll(SEL);
    var todo=[];
    for(var i=0;i<els.length;i++){if(!els[i].hasAttribute('data-ppj'))todo.push(els[i]);}
    if(!todo.length)return;
    l.disabled=true;
    var info=todo.map(function(e){return {a:getComputedStyle(e).textAlign,w:e.getBoundingClientRect().width,inLink:!!e.closest('a')};});
    l.disabled=false;
    todo.forEach(function(e,i){
      var o=info[i];
      e.setAttribute('data-ppj','1');
      if(o.a==='center'||o.a==='right'||o.a==='end'){e.style.textAlign=o.a;e.setAttribute('data-ppj-set','1');}
      else if(o.w>0&&(o.w<MIN||o.inLink)){e.style.textAlign='left';e.setAttribute('data-ppj-set','1');}
    });
  }
  function reset(){
    var els=document.querySelectorAll('[data-ppj]');
    for(var i=0;i<els.length;i++){
      if(els[i].hasAttribute('data-ppj-set')){els[i].style.textAlign='';els[i].removeAttribute('data-ppj-set');}
      els[i].removeAttribute('data-ppj');
    }
    run();
  }
  var t,lastW=window.innerWidth;
  function later(){clearTimeout(t);t=setTimeout(run,150);}
  function start(){
    run();
    var m=document.getElementById('MainContent');
    if(m&&window.MutationObserver){new MutationObserver(later).observe(m,{childList:true,subtree:true});}
    window.addEventListener('resize',function(){if(window.innerWidth!==lastW){lastW=window.innerWidth;clearTimeout(t);t=setTimeout(reset,250);}});
    window.addEventListener('load',function(){setTimeout(reset,400);});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();
